import * as PIXI from "pixi.js";

import { Button } from "@src/core/ui/components/Button";
import { Popup } from "@src/core/ui/components/Popup";
import { gameEngine } from "@src/game/GameEngine";
import { constants } from "@src/game/Constants";

export class BetsPopup extends Popup {
  protected title: string = "";
  public width: number = 0;
  public height: number = 0;

  private COLUMNS: number = 0;
  private _selectBetButtons: Button[] = [];

  public constructor() {
    console.log("BetsPopup constructor called");
    console.trace(); // This will show you the call stack
    super();
  }

  protected initializeComponents(): void {
    this.title = "Bet";
    this.width = 700;
    this.height = 700;

    this.COLUMNS = 4;
    this._selectBetButtons = [];

    super.initializeComponents();
  }

  protected initializeContent(): void {
    // TODO: Get the real bet array from the server response
    const dummyBetArray: number[] = [
      0.1, 0.2, 0.5, 1, 1.5, 2, 5, 10, 20, 30, 50, 100,
    ];
    const rows: number = Math.ceil(dummyBetArray.length / this.COLUMNS);

    // Calculate button size and spacing based on content area
    const buttonSpacing: number = 20;
    const availableWidth: number =
      this.contentSizeX - buttonSpacing * (this.COLUMNS - 1);
    const buttonWidth: number = availableWidth / this.COLUMNS;
    const buttonHeight: number = 70;

    // Calculate total height used by the grid
    const totalGridHeight: number =
      rows * buttonHeight + (rows - 1) * buttonSpacing;

    // Start from TOP-LEFT of content area, but offset to center vertically
    const startX: number = -this.contentSizeX / 2 + buttonWidth / 2;
    const startY: number = -totalGridHeight / 2 + buttonHeight / 2; // Center the grid vertically

    for (let i = 0; i < dummyBetArray.length; i++) {
      const bet: number = dummyBetArray[i];
      const row: number = Math.floor(i / this.COLUMNS);
      const column: number = i % this.COLUMNS;

      const selectBetButton = this._createSelectBetButton(
        buttonWidth,
        buttonHeight,
        bet,
      );
      selectBetButton.setActive(false);
      this._selectBetButtons.push(selectBetButton);

      // Position from top-left, left-to-right
      const x = startX + column * (buttonWidth + buttonSpacing);
      const y = startY + row * (buttonHeight + buttonSpacing);

      selectBetButton.view.position.set(x, y);
      this.content.addChild(selectBetButton.view);
    }

    this._selectBetButtons[3].setActive(true);

    super.initializeContent();
  }

  private _createSelectBetButton(
    width: number,
    height: number,
    betValue: number,
  ): Button {
    const buttonBackgroundActive: PIXI.Graphics = new PIXI.Graphics();
    buttonBackgroundActive.roundRect(
      -width / 2,
      -height / 2,
      width,
      height,
      height / 2,
    );
    buttonBackgroundActive.stroke({ width: 3, color: 0xffffff });

    const buttonBackgroundInactive: PIXI.Graphics = new PIXI.Graphics();
    buttonBackgroundInactive.roundRect(
      -width / 2,
      -height / 2,
      width,
      height,
      height / 2,
    );
    // NOTE: In pixijs, if a graphics object doesnt have a fill property
    // than it can not be clicked
    // We utilize that functionality to make already selected buttons unselectable
    buttonBackgroundInactive.fill(0x000000);
    buttonBackgroundInactive.stroke({ width: 3, color: 0x333333 });

    const betLabel = new PIXI.Text({
      text: gameEngine.formatter.format(betValue),
      style: {
        fill: "#ffffff",
        fontSize: 30,
        fontWeight: "bold",
        fontFamily: "uiFont",
        align: "center",
      },
    });
    betLabel.anchor.set(0.5);

    const buttonsArray = this._selectBetButtons;

    const selectBetButton: Button = new Button(
      constants.UIButtonTypes.BET_SELECTION,
    );

    selectBetButton.activeGraphics = buttonBackgroundActive;
    selectBetButton.inactiveGraphics = buttonBackgroundInactive;
    selectBetButton.clickArgs = gameEngine.formatter.format(betValue);
    selectBetButton.onClick = () => {
      buttonsArray.forEach((button) => button.setActive(false));
      selectBetButton.setActive(true);
      gameEngine.bet = betValue;
    };

    selectBetButton.view.addChild(betLabel);

    return selectBetButton;
  }
}
